import { API_ENDPOINTS, DINEOUT_CART_API_HOST, GANDALF_API_HOST } from "constants/api";
import { makeApiCall } from "@swiggy-private/js-utils";
import { PlaceOrderParams } from "types";
import type { IPlaceOrderResponseData } from "../components/CartOrders/CartTab/interface";
import { customApiCall, IOptions } from "../utils/api";

export const placeOrder = async (
    params: PlaceOrderParams,
    _makeApiCall: typeof makeApiCall,
    // New dineout host/endpoint when enabled; legacy GANDALF create-order endpoint as backup.
    useDineoutCartHostTrackOrder = true,
) => {
    const options: IOptions = {
        bodyParams: { ...params },
        method: "POST",
    };
    const response = await customApiCall<IPlaceOrderResponseData>({
        _makeApiCall,
        apiHost: useDineoutCartHostTrackOrder ? DINEOUT_CART_API_HOST : GANDALF_API_HOST,
        apiEndpoint: useDineoutCartHostTrackOrder ? API_ENDPOINTS.TRACK_ORDER : API_ENDPOINTS.CREATE_ORDER_OLD,
        opts: options,
    });

    return response;
};

export const getPaymentOptions = async (
    params: { parentOrderId?: string; restaurantId?: string; tableId?: string },
    _makeApiCall: typeof makeApiCall,
) => {
    const options: IOptions = {
        bodyParams: { ...params },
        method: "POST",
    };
    const response = await customApiCall({
        _makeApiCall,
        apiHost: DINEOUT_CART_API_HOST,
        apiEndpoint: API_ENDPOINTS.GET_PAYMENT_OPTIONS,
        opts: options,
    });
    return response;
};
